import { Capacitor, registerPlugin } from '@capacitor/core';

const FloatingBubble = registerPlugin('FloatingBubble');

const isAndroidNative = () =>
  Capacitor.isNativePlatform?.() && Capacitor.getPlatform?.() === 'android';

/**
 * Check if the app has permission to draw overlay widgets over other apps.
 */
export const checkBubblePermission = async () => {
  if (!isAndroidNative() || !FloatingBubble?.checkPermission) {
    return { granted: false };
  }
  try {
    return await FloatingBubble.checkPermission();
  } catch (e) {
    console.warn('checkBubblePermission failed:', e);
    return { granted: false };
  }
};

/**
 * Open Android Settings to grant "Display over other apps" permission.
 */
export const requestBubblePermission = async () => {
  if (!isAndroidNative() || !FloatingBubble?.requestPermission) {
    return { granted: false };
  }
  try {
    return await FloatingBubble.requestPermission();
  } catch (e) {
    console.warn('requestBubblePermission failed:', e);
    return { granted: false };
  }
};

/**
 * Show the floating circular return head on top of Google Maps / other apps.
 */
export const showFloatingBubble = async () => {
  if (!isAndroidNative() || !FloatingBubble?.show) return false;
  try {
    const { granted } = await checkBubblePermission();
    if (!granted) {
      // First time request permission prompt
      await requestBubblePermission();
      return false;
    }
    await FloatingBubble.show();
    return true;
  } catch (e) {
    console.warn('showFloatingBubble failed:', e);
    return false;
  }
};

/**
 * Hide the floating return head when trip ends or app is in foreground.
 */
export const hideFloatingBubble = async () => {
  if (!isAndroidNative() || !FloatingBubble?.hide) return false;
  try {
    await FloatingBubble.hide();
    return true;
  } catch (e) {
    console.warn('hideFloatingBubble failed:', e);
    return false;
  }
};
